import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';

export default function CampaignTestSendModal({ show, campaign, onClose }) {
    const [sending, setSending] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleSend = async () => {
        setSending(true);
        setResult(null);
        setError(null);
        try {
            const res = await axios.post(
                `/api/campaigns/${campaign.id}/test-send/`,
                {},
                { withCredentials: true }
            );
            setResult(res.data.detail);
        } catch (err) {
            setError(err.response?.data?.detail || 'Test send failed.');
        } finally {
            setSending(false);
        }
    };

    const handleClose = () => {
        setResult(null);
        setError(null);
        onClose();
    };

    if (!campaign) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Send test email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-1 small">
                    A test copy of <strong>{campaign.title}</strong> will be sent to your email address.
                </p>
                {result && <div className="alert alert-success small py-2 mt-2">{result}</div>}
                {error && <div className="alert alert-danger small py-2 mt-2">{error}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {result ? 'Close' : 'Cancel'}
                </Button>
                {!result && (
                    <Button variant="outline-primary" onClick={handleSend} disabled={sending}>
                        {sending ? 'Sending…' : 'Send test'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}
